<div style="position: relative;">
  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <div class="w-100 h-100">
    <div class="d-flex w-100">
      <div class="mr-2">
        <span>Start Month: </span>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [formControl]="startTime" [max]="max" readonly>
          <owl-date-time [pickerType]="'calendar'" [startView]="'multi-years'" (yearSelected)="chosenYearHandler($event, startTime)"
            (monthSelected)="chosenMonthHandler($event, dt1, startTime)" #dt1="owlDateTime"></owl-date-time>
        </mat-form-field>
      </div>
      <div>
        <span>End Month: </span>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [formControl]="endTime" [min]="min" [max]="currentDate" readonly>
          <owl-date-time [pickerType]="'calendar'" [startView]="'multi-years'" (yearSelected)="chosenYearHandler($event, endTime)"
            (monthSelected)="chosenMonthHandler($event, dt2, endTime)" #dt2="owlDateTime"></owl-date-time>
        </mat-form-field>
      </div>
    </div>
    <div class="w-100 d-flex justify-content-center">
      <button class="btn btn-save btn-primary button" (click)="apply()">Download</button>
    </div>
  </div>
</div>
